import { Injectable } from '@angular/core';
import { SingletonServiceGuard } from '@lsq-frontend/angular-shared/features/generic-get-services';
import { Modal } from '../../models/common';
import { ModalService } from '../../services/modal/modal.service';

/**
 * TODO: Investigate whether it's a good idea to listen for the `window`'s `beforeunload` event.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events/beforeunload
 */
@Injectable({ providedIn: 'root' })
export class WorkflowMonitorService {
    private _isWorkflowInProgress = false;
    private _bodyCopy?: string;
    private _dismissWarningCopy?: string;
    private _heedWarningCopy?: string;

    constructor(private _modalService: ModalService) {
        SingletonServiceGuard.register('WorkflowMonitorService');
    }

    public get isWorkflowInProgress(): boolean {
        return this._isWorkflowInProgress;
    }

    public markWorkflowStarted(
        bodyCopy?: string,
        dismissWarningCopy?: string,
        heedWarningCopy?: string
    ): void {
        this._isWorkflowInProgress = true;
        this._bodyCopy = bodyCopy;
        this._dismissWarningCopy = dismissWarningCopy;
        this._heedWarningCopy = heedWarningCopy;
    }

    public markWorkflowFinished(): void {
        this._isWorkflowInProgress = false;
        this._clear();
    }

    public markWorkflowCancelled(): void {
        this._isWorkflowInProgress = false;
        this._clear();
    }

    public warn(onOkClickCallback: (...args: any[]) => any): void {
        const bodyCopy =
            this._bodyCopy ||
            'You have unsaved changes that will be discarded if you navigate away. Are you sure you want to leave this page?';
        const dismissWarningCopy = this._dismissWarningCopy || 'Yes, discard';
        const heedWarningCopy = this._heedWarningCopy || 'No, keep working';
        this._modalService.showModal(
            new Modal({
                id: 'unsaved-changes-modal',
                title: 'Are you sure?',
                bodyText: bodyCopy,
                showFooter: true,
                okButtonText: dismissWarningCopy,
                cancelButtonText: heedWarningCopy,
                showOkButton: true,
                showCancelButton: true,
                onOkClick: () => {
                    this.markWorkflowCancelled();
                    this._modalService.closeModal();
                    onOkClickCallback();
                }
            })
        );
    }

    private _clear(): void {
        this._bodyCopy = null;
        this._dismissWarningCopy = null;
        this._heedWarningCopy = null;
    }
}
